<template>
    <div>
        <div v-if="lineups && lineups[0] && lineups[1]">
            <h5>Jersey</h5>
            <table class="table">
                <tr>
                    <th>home</th>
                    <th>away</th>
                </tr>
                <tr>
                    <td>
                        base: {{ lineups[0].jersey.base}}<br>
                        horizontal_stripes: {{ lineups[0].jersey.horizontal_stripes}}<br>
                        number: {{ lineups[0].jersey.number}}<br>
                        shirt_type: {{ lineups[0].jersey.shirt_type}}<br>
                        sleeve: {{ lineups[0].jersey.sleeve}}<br>
                        sleeve_detail: {{ lineups[0].jersey.sleeve_detail}}<br>
                        split: {{ lineups[0].jersey.split}}<br>
                        squares: {{ lineups[0].jersey.squares}}<br>
                        stripes: {{ lineups[0].jersey.stripes}}<br>
                        type: {{ lineups[0].jersey.type}}<br>
                    </td>
                    <td>
                        base: {{ lineups[1].jersey.base}}<br>
                        horizontal_stripes: {{ lineups[1].jersey.horizontal_stripes}}<br>
                        number: {{ lineups[1].jersey.number}}<br>
                        shirt_type: {{ lineups[1].jersey.shirt_type}}<br>
                        sleeve: {{ lineups[1].jersey.sleeve}}<br>
                        sleeve_detail: {{ lineups[1].jersey.sleeve_detail}}<br>
                        split: {{ lineups[1].jersey.split}}<br>
                        squares: {{ lineups[1].jersey.squares}}<br>
                        stripes: {{ lineups[1].jersey.stripes}}<br>
                        type: {{ lineups[1].jersey.type}}<br>
                    </td>
                </tr>
            </table>
       </div>
        <div v-for="lineup in lineups" :key="lineup.id">
            <h5>starting_lineup</h5>

            <table class="table">
                <tr>
                    <th>id</th>
                    <th>name</th>
                    <th>jersey_number</th>
                    <th>order</th>
                    <th>position</th>
                    <th>type</th>
                </tr>
                <tr v-for="player in lineup.players" :key="player.id">
                    <td>{{ player.id }}</td>
                    <td>{{ player.name }}</td>
                    <td>{{ player.jersey_number }}</td>
                    <td>{{ player.order }}</td>
                    <td>{{ player.position }}</td>
                    <td>{{ player.type }}</td>
                </tr>
            </table>            
        </div>
    </div>
    
</template>

<script>
export default {
    name: 'SoccerScoresLineups',
    props: {
        lineups: ''
    }
}
</script>

